import { jsx } from "react/jsx-runtime";
import MonitorIcon from "@mui/icons-material/Monitor";
import { validateTidalLicense } from "../../base/index.js";
function Monitor(props) {
  return /* @__PURE__ */ jsx(
    MonitorIcon,
    {
      "data-testid": "Monitor",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Monitor",
      "data-tidal-icon-meta": "devices,photos"
    }
  );
}
Monitor.tidalIconMeta = {
  categories: "devices,photos",
  name: "Monitor"
};
validateTidalLicense();
export {
  Monitor
};
//# sourceMappingURL=Monitor.js.map
